export default function shouldRenderAppBar(pathname) {
    const controlRoutes = new Set(['/sign-up', '/login']);

    return !controlRoutes.has(pathname);
}
